import { Button, Grid } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { FreeTrialDialog } from "components/shared/free-trial-dialog";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CustomCTA as CUSTOMCTA, GetUrlBuilderData } from "store/url-builder";
import dashedButtonStyle from "styles/buttons/dashed-button.module.scss";
import roundedButtonStyle from "styles/buttons/rounded-button.module.scss";
import { isWhite } from "utils";
import { CustomCTADialog } from "./custom-cta-dialog";

export interface CustomCTAProps {
  builderType: string;
  isFree?: boolean | null;
}

export const CustomCTA = ({ builderType, isFree = null }: CustomCTAProps) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [freeTrialDialog, setFreeTrialDialog] = useState(false);
  const builderData = useSelector(GetUrlBuilderData);

  const [ctaList, setCtaList] = useState<CUSTOMCTA[]>([]);

  useEffect(() => {
    const buttonTexts = builderData.customCTA.buttonText
      ? builderData.customCTA.buttonText.split("#lcard;")
      : [];
    const buttonLinks = builderData.customCTA.buttonLink
      ? builderData.customCTA.buttonLink.split("#lcard;")
      : [];
    const buttonColor = builderData.customCTA.buttonColor
      ? builderData.customCTA.buttonColor.split("#lcard;")
      : buttonTexts.map((item) => builderData.primaryColor.color);

    let temp: CUSTOMCTA[] = [];

    buttonTexts.forEach((item, index) => {
      if (item && buttonLinks[index])
        temp.push({
          buttonText: item,
          buttonLink: buttonLinks[index],
          buttonColor: buttonColor[index],
        });
    });

    setCtaList(temp);
  }, [builderData.customCTA, builderData.primaryColor.color]);

  const openFreeTrialDialog = () => setFreeTrialDialog(true);
  const handleCloseFreeTrialDialog = () => setFreeTrialDialog(false);

  return (
    <Grid item container xs={12}>
      <Grid item xs={12} className="mb-4">
        <Button
          onClick={!isFree ? () => setOpenDialog(true) : openFreeTrialDialog}
          classes={{ root: dashedButtonStyle.root }}
          fullWidth
        >
          <AddIcon /> {ctaList.length > 0 ? 'Add/Edit Custom CTA Button' : 'Add Custom CTA Button'}
        </Button>
      </Grid>
      {ctaList.map((cta, index) => (
        <Grid item xs={12} key={index} className="mb-2">
          <Button
            onClick={() => window.open(cta.buttonLink, "_blank")}
            style={{
              backgroundColor: cta.buttonColor,
              color: isWhite(cta.buttonColor || "") ? "#262626" : "#fff",
              border: isWhite(cta.buttonColor || "")
                ? "1px solid rgba(38,38,38,0.5)"
                : "none",
            }}
            className={roundedButtonStyle.root}
            size="large"
            variant="contained"
            color="primary"
            fullWidth
          >
            {cta.buttonText}
          </Button>
        </Grid>
      ))}
      {openDialog && (
        <CustomCTADialog
          isOpen={openDialog}
          onClose={() => setOpenDialog(false)}
          builderType={builderType}
          ctaList={ctaList}
        />
      )}
      {freeTrialDialog && <FreeTrialDialog isOpen={freeTrialDialog} onClose={handleCloseFreeTrialDialog} />}
    </Grid>
  );
};
